<template>
    <div>
        <v-container grid-list-xl fluid class="pt-0">
            <v-layout row wrap>
                <v-flex sm12>
                    <v-card>
                        <v-toolbar color="primary" dark flat>
                            <v-toolbar-title>
                                <v-icon medium>fa fa-cog</v-icon>
                                Lista de Areas
                            </v-toolbar-title>

                            <v-divider class="mx-2" inset vertical></v-divider>

                            <v-flex sm3 class="pa-0" style="max-width: 190px">
                                <v-overflow-btn
                                    v-model="areaEstado"
                                    label="Área"
                                    :items="[
                                        { text: 'Todos', value: '1' },
                                        { text: 'Habilitados', value: '2' },
                                        { text: 'Deshabilitados', value: '3' }
                                    ]"
                                    hide-details
                                    class="pa-0"
                                    @change="loadArea()"
                                >
                                    <template v-slot:item="data">
                                        <v-list-tile-content>
                                            <v-card-text class="pa-0 ">
                                                <v-icon
                                                    :color="getIconColor(data)"
                                                    class="pr-3"
                                                    v-if="data.item.value !== '1'"
                                                    >fa-list</v-icon
                                                >
                                                {{ data.item.text }}
                                            </v-card-text>
                                        </v-list-tile-content>
                                    </template>
                                </v-overflow-btn>
                            </v-flex>

                            <v-divider class="px-1" inset vertical></v-divider>

                            <v-spacer></v-spacer>

                            <v-toolbar-items>
                                <v-btn icon @click="toogleSearch()">
                                    <v-icon medium>fa-search</v-icon>
                                </v-btn>

                                <v-expand-x-transition>
                                    <v-text-field
                                        hide-details
                                        solo
                                        v-show="searchShow"
                                        v-model="filter.search"
                                        placeholder="Filtrar"
                                        class="hidden-sm-and-down pt-2"
                                    >
                                    </v-text-field>
                                </v-expand-x-transition>

                                <v-divider class="pa-2"></v-divider>

                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn icon flat @click="openForm(null)">
                                            <v-icon medium v-on="on">fa-plus</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Agregar Área</span>
                                </v-tooltip>
                            </v-toolbar-items>
                        </v-toolbar>
                        <v-divider></v-divider>
                        <v-card-text class="pa-0">
                            <v-data-table
                                :headers="headers"
                                :loading="loading"
                                :pagination.sync="pagination"
                                :rows-per-page-items="pagination.rowsPerPageItems"
                                :total-items="totalItems"
                                :items="AREAS"
                                class="elevation-1"
                                item-key="id"
                            >
                                <v-progress-linear v-slot:progress color="green" indeterminate></v-progress-linear>
                                <template slot="items" slot-scope="props">
                                    <tr>
                                        <td>{{ props.item.nombre }}</td>
                                        <td>
                                            <v-chip
                                                small
                                                dark
                                                :color="getChipColor(props.item)"
                                                style="font-size: 12px"
                                            >
                                                {{
                                                    props.item.status_description ? props.item.status_description : "-"
                                                }}
                                            </v-chip>
                                            <div class="action-column">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            flat
                                                            icon
                                                            color="orange"
                                                            :disabled="loading || menuLocked"
                                                            @click="openForm(props.item)"
                                                        >
                                                            <v-icon medium v-on="on">fa-edit</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Editar Area</span>
                                                </v-tooltip>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            flat
                                                            icon
                                                            color="red"
                                                            :disabled="loading || menuLocked"
                                                            @click="deleteItem(props)"
                                                        >
                                                            <v-icon medium v-on="on">fa-trash</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Eliminar Area</span>
                                                </v-tooltip>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            flat
                                                            icon
                                                            color="grey"
                                                            :loading="loadingHistory"
                                                            :disabled="loading || menuLocked"
                                                            @click="loadHistory(props.item)"
                                                        >
                                                            <v-icon medium v-on="on">fa-archive</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Ver historial</span>
                                                </v-tooltip>
                                            </div>
                                        </td>
                                    </tr>
                                </template>
                                <template v-slot:expand="props">
                                    <v-card>
                                        <v-card-text class="py-0 pl-0 text-xs-right">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn icon flat color="red" @click="deleteItemCancel(props)">
                                                        <v-icon v-on="on">fa-close</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Cancelar acción</span>
                                            </v-tooltip>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn icon flat color="green" @click="deleteItemConfirm(props)">
                                                        <v-icon v-on="on">fa-check</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Confirmar acción</span>
                                            </v-tooltip>
                                        </v-card-text>
                                    </v-card>
                                </template>
                                <template slot="no-data">
                                    <div style="text-align: center">
                                        No existen areas registrados en el sistema.
                                    </div>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <area-form v-if="showForm" :form-title="title" :initial-item="editItem" @formCanceled="closeForm"> </area-form>

        <time-line
            v-if="showHistory"
            :data="historyData"
            :element="'Activo área'"
            @formCanceled="showHistory = false"
        ></time-line>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import _ from "lodash"
import Util from "@/util"
const TimeLine = () => import("@/components/widgets/records-time-line/time-line")
const AreaForm = () => import("@/components/finanzas/nomencladores/area-form/area-form")

export default {
    components: { AreaForm, TimeLine },
    props: {},
    data: () => ({
        searchShow: false,
        loading: false,
        title: "",
        showForm: false,
        headers: [{ text: "Área", value: "nombre" }, { text: "Estado", value: "estado" }],
        editItem: null,
        filter: {
            search: ""
        },
        totalItems: 0,

        deleteAreaConfirmId: "",

        menuLocked: false,

        //estado de los areas a cargar del back
        areaEstado: "1",

        //history
        loadingHistory: false,
        showHistory: false,
        historyData: null
    }),

    methods: {
        toogleSearch: function() {
            this.searchShow = !this.searchShow
        },

        loadData(estado) {
            this.loading = true
            this.$store.dispatch("LOAD_AREAS", { filter: this.filter.search, areaEstado: estado }).then(result => {
                this.loading = false
                this.totalItems = result
            })
        },

        openForm(item) {
            if (item !== null) {
                this.title = "Modificar área"
                this.editItem = item
            } else {
                this.title = "Nuevo área"
            }
            this.showForm = true
        },

        closeForm() {
            this.showForm = false
            this.editItem = null
        },

        deleteItem(props) {
            this.menuLocked = true
            this.deleteAreaConfirmId = props.item.id
            props.expanded = true
        },

        deleteItemConfirm(props) {
            if (this.deleteAreaConfirmId === props.item.id) {
                this.loading = true
                this.$store.dispatch("DELETE_AREA", props.item).then(() => {
                    this.loading = false
                    this.menuLocked = false
                    this.deleteAreaConfirmId = ""
                    props.expanded = !props.expanded
                })
            }
        },

        deleteItemCancel(props) {
            this.menuLocked = false
            this.deleteAreaConfirmId = ""
            props.expanded = !props.expanded
        },

        loadArea() {
            this.loadData(this.areaEstado)
        },

        loadHistory(item) {
            this.loadingHistory = true

            let historyClassName = Util.getHistoryClassName("Area")
            this.$store.commit("SET_HISTORIALES_TIME_LINE_PAG", { page: 1 })
            this.$store
                .dispatch("LOAD_HISTORIALES_TIME_LINE", { class: historyClassName, class_id: item.id })
                .then(response => {
                    if (response) {
                        this.historyData = this.$store.getters.HISTORIALES_TIME_LINE.historiales
                        this.showHistory = true
                        this.loadingHistory = false
                    } else {
                        this.loadingHistory = false
                    }
                })
        },

        searchData: _.debounce(function() {
            this.loadData(this.areaEstado)
        }, 1000),

        getChipColor(item) {
            switch (item.estado) {
                case 1:
                    return "success lighten-1"
                case 0:
                    return "grey lighten-1"
            }
        },

        getIconColor(data) {
            switch (data.item.value) {
                case "1":
                    return "black"
                case "2":
                    return "success lighten-1"
                case "3":
                    return "grey lighten-1"
                default:
                    return "black"
            }
        }
    },

    computed: {
        ...mapGetters(["AREAS"]),

        pagination: {
            get: function() {
                return this.$store.getters.AREAS_PAG
            },
            set: function(value) {
                this.$store.commit("SET_AREAS_PAG", value)
            }
        },
        searchTerm() {
            return this.filter.search
        }
    },

    watch: {
        pagination: {
            handler() {
                this.loadData(this.areaEstado)
            },
            deep: true
        },
        searchTerm() {
            this.searchData()
        }
    }
}
</script>

<style scoped></style>
